import { array } from '@ember/helper';
import { action } from '@ember/object';
import { schedule } from '@ember/runloop';
import Component from '@glimmer/component';

import $ from 'jquery';

import joinClasses from 'webapp/helpers/join-classes';
import didInsert from 'webapp/modifiers/did-insert';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import ToolTipComponent from 'webapp/components/tool-tip';

interface Args {
	text?: string | JQuery<HTMLElement>;
	extraClass?: string;
	maxWidth?: number;
	position?: string;
	theme?: string | null;
	appendTo?: string;
	spaceRight?: boolean;
	iconName?: IconName;
	iconSize?: IconSize;
	onClose?: () => void;
}

export default class ToolTipWithIconComponent extends Component<Args> {
	get themeClass() {
		if (this.args.theme) {
			return `tooltipster-theme-${this.args.theme}`;
		}
		return '';
	}

	get spaceRight() {
		return !!this.args.spaceRight;
	}

	get position() {
		return this.args.position || 'top';
	}

	get iconName() {
		return this.args.iconName || 'InfoFill';
	}

	get iconSize() {
		return this.args.iconSize || 'xs';
	}

	@action
	setupView(node: HTMLElement) {
		const appendToSelector = this.args.appendTo;
		if (appendToSelector) {
			const el = $(node),
				helperContainer = el.find(appendToSelector);

			schedule('afterRender', this, () => {
				if (helperContainer) {
					el.appendTo(helperContainer);
				}
			});
		}
	}
	<template>
		<div
			class={{joinClasses
				(array "tooltipster-wrapper" this.themeClass (if this.spaceRight "space-right"))
			}}
			{{didInsert this.setupView}}
		>
			<CommonUiIconComponent @name={{this.iconName}} @size={{this.iconSize}} @class="icon" />

			<ToolTipComponent
				@position={{this.position}}
				@extraClass={{@extraClass}}
				@text={{@text}}
				@interactive={{true}}
				@maxWidth={{@maxWidth}}
				@theme={{@theme}}
				@onClose={{@onClose}}
			/>
		</div>
	</template>
}
